export const GET_LIST_USERS = '/user/list';
export const GET_USER_INFO = '/user/getById';
export const CREATE_USER = '/user/create';
export const UPDATE_USER = '/user/update';
export const DELETE_USER = '/user/delete';
